import React from 'react';
import './TimeoutModal.css';

const TimeoutModal = ({ countdown, onStayInSession, onLogout }) => {
  return (
    <>
      <div className="timeout-modal-overlay" />
      <div className="timeout-modal-container">
        <div className="timeout-modal">
          <div className="timeout-modal-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6v6l4 2" />
            </svg>
          </div>

          <h2 className="timeout-modal-title">Session Timeout Warning</h2>
          
          <p className="timeout-modal-message">
            You have been inactive for a while. Do you want to stay in this session?
          </p>

          <div className="timeout-modal-countdown">
            <span className="countdown-label">Auto logout in</span>
            <span className="countdown-value">{countdown}</span>
            <span className="countdown-unit">seconds</span>
          </div>

          <div className="timeout-modal-actions">
            <button 
              className="timeout-modal-btn timeout-modal-btn-primary"
              onClick={onStayInSession}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 12l2 2 4-4" />
                <circle cx="12" cy="12" r="10" />
              </svg>
              Stay in Session
            </button>
            
            <button 
              className="timeout-modal-btn timeout-modal-btn-secondary"
              onClick={onLogout}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TimeoutModal;
